import { colorConfig } from "./config";

const getColors = () => {
  if (false) return colorConfig.dark;
  else return colorConfig.light;
};

export const colors = getColors();
